import { render, staticRenderFns } from "./CertificationParameters.vue?vue&type=template&id=7ebf6923&scoped=true&"
import script from "./CertificationParameters.vue?vue&type=script&lang=js&"
export * from "./CertificationParameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebf6923",
  null
  
)

export default component.exports